import { Filter } from 'types/Search/filter';
import {
    DestinationValue,
    DurationType,
    OccupancyValue,
    Pagination,
    Search,
    SearchFormState,
    SortOrder,
} from 'types/Search/form';

import { FilterInformation } from 'proto/Search/FilterMeta';
import { PriceRange } from 'proto/Search/PriceRange';

export const emptyDestination: DestinationValue = {
    regionGroupIdList: new Set(),
    countryIdList: new Set(),
    regionIdList: new Set(),
    cityIdList: new Set(),
};

export const defaultOccupancyValue: OccupancyValue = [
    {
        adultCount: 2,
        childAgeList: [],
    },
];

export const defaultPagination: Pagination = {
    pageCount: 1,
    currentPage: 1,
};

export const defaultFilter: Filter = {
    accommodation: {
        mealTypeList: new Set(),
        roomTypeList: new Set(),
        roomClassList: new Set(),
        viewTypeList: new Set(),
        poolTypeList: new Set(),
        exteriorList: new Set(),
        hotelCategoryList: new Set(),
        accommodationCategoryList: new Set(),
        attributesList: new Set(),
        withHygieneFacts: false,
    },
    flight: {
        airlineList: new Set(),
        destinationAirportList: new Set(),
        directFlight: false,
        hideMixFlights: false,
        withNoBag: false,
    },
    special: {
        lowDeposit: false,
        reservable: false,
        rebookable: false,
        promoDiscount: false,
    },
    transfer: {
        hotelTransfer: false,
        privateTransfer: false,
        railAndFly: false,
    },
    paymentTypeList: new Set(),
    tourOperatorList: new Set(),
    tourOperatorCategoryList: new Set(),
};

export const defaultSearch: Search = {
    destination: emptyDestination,
    departureAirportList: new Set(),
    travelPeriod: {
        duration: {
            type: DurationType.Empty,
        },
    },
    occupancy: {
        adultCount: 2,
        childCount: 0,
        allocation: defaultOccupancyValue,
    },
    sorting: {
        region: SortOrder.Price,
        hotel: SortOrder.Price,
        offer: SortOrder.Price,
    },
    pagination: defaultPagination,
    filter: defaultFilter,
    unknownParams: {},
};

export const defaultPriceRange: PriceRange = {
    minPrice: 0,
    maxPrice: 0,
    rangeList: [
        { count: 0, max: 0, min: 0 },
        { count: 0, max: 0, min: 0 },
    ],
};

export const defaultFilterInformation: FilterInformation =
    FilterInformation.fromPartial({
        priceRange: defaultPriceRange,
    });

export const defaultSearchFormState: SearchFormState = {
    current: defaultSearch,
    recent: null,
    default: defaultSearch,
    meta: defaultFilterInformation,
};

export const defaultCountPerPage = 25;
export const defaultFilterDebounceTime = 1000;
